module.exports = __webpack_public_path__ + "img/jyzCode.76e3c51e.png";